import React from "react";
import CareersSubNav from "../components/careersSubNav";

const steps = [
  { title: "Send your profile", description: "Email info@nirkana.com or use WhatsApp on the role's page — no long application form to fill out." },
  { title: "A short screening call", description: "A quick call to understand your experience and what you're looking for, and to answer your questions about the role." },
  { title: "Conversation with the founders", description: "Since we're a small team, you'll speak directly with the people you'd be working with — not a rotating panel." },
  { title: "Offer", description: "If it's a fit on both sides, we move quickly. Compensation and expectations are discussed openly at this stage." },
];

const HowWeHire = () => {
  return (
    <div>
      <section className="bg-cloud py-14 lg:py-20">
        <div className="max-w-content mx-auto px-6 lg:px-10">
          <h1 className="text-3xl font-bold text-brand sm:text-4xl">How we hire</h1>
          <p className="mt-4 max-w-prose text-muted">
            We're a small, early-stage team, so our process is short and
            direct — no lengthy multi-round pipeline.
          </p>
        </div>
      </section>

      <CareersSubNav />

      <section className="bg-paper py-16 lg:py-24">
        <div className="max-w-content mx-auto px-6 lg:px-10">
          <ol className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
            {steps.map((step, index) => (
              <li key={step.title} className="rounded-xl border border-line bg-cloud p-6">
                <span className="flex h-8 w-8 items-center justify-center rounded-full bg-brand text-sm font-semibold text-paper">
                  {index + 1}
                </span>
                <h3 className="mt-4 text-base font-semibold text-charcoal">{step.title}</h3>
                <p className="mt-2 text-sm text-muted">{step.description}</p>
              </li>
            ))}
          </ol>
        </div>
      </section>
    </div>
  );
};

export default HowWeHire;
